/**
 * Utility functions for extracting product category hierarchy
 */

/**
 * Extracts list hierarchy from product category data using pipe separator
 * @param product - Product object with categoryName property
 * @returns Formatted hierarchy string (e.g., "Cycling|Road|Helmets") or undefined
 *
 * Examples:
 * - product.categoryName = ["Cycling", "Road", "Helmets"] → "Cycling|Road|Helmets"
 * - product.categoryName = ["Snow", "Backcountry", "Protection"] → "Snow|Backcountry|Protection"
 * - product.categoryName = ["Cycling", "Gravel"] → "Cycling|Gravel"
 */
export const extractProductHierarchy = (product: any): string | undefined => {
    if (!product?.categoryUri) {
        return undefined
    }

    return product.categoryUri
        .split("/")
        .map((segment: string) => segment.charAt(0).toUpperCase() + segment.slice(1))
        .join("|")
}

/**
 * Extracts canonical category from product using forward slash separator
 * @param product - Product object with categoryName property
 * @returns Formatted category string (e.g., "cycling/road/helmets") or empty string
 */
export const extractCanonicalCategory = (product: any): string => {
    if (!product?.categoryName) {
        return ""
    }

    const categoryNames = Array.isArray(product.categoryName) ? product.categoryName : []

    if (categoryNames.length === 0) {
        return ""
    }

    // Join category names with forward slash and convert to lowercase
    return categoryNames.map((category: string) => category.toLowerCase()).join("/")
}
